import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Injector, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { Table, TableModule, TableService, TableRowExpandEvent, TableRowCollapseEvent } from 'primeng/table';
import { PatientSessionModel } from '../../../core/api/models';

/** Shared table lifecycle; mode controllers supply their permitted columns and actions. */
@Component({selector: 'app-session-list', standalone: true, imports: [CommonModule, TableModule],
  templateUrl: './session-list.component.html'})
export class SessionListComponent {
  @Input() sessions: PatientSessionModel[] = [];
  @Input() loading = false;
  @Input() rows = 25;
  @Input() minimumWidth = '70rem';
  @Input() headerTemplate!: TemplateRef<any>;
  @Input() rowTemplate!: TemplateRef<any>;
  @Input() expandedTemplate!: TemplateRef<any>;
  @Input() emptyTemplate: TemplateRef<any> | null = null;
  @Output() rowExpand = new EventEmitter<TableRowExpandEvent>();
  @Output() rowCollapse = new EventEmitter<TableRowCollapseEvent>();
  private injector = inject(Injector);
  private tableInstance!: Table;
  tableInjector: Injector | null = null;
  get table(): Table { return this.tableInstance; }
  @ViewChild('table', {static: true}) set tableView(table: Table) {
    this.tableInstance = table;
    this.tableInjector = Injector.create({providers: [
      {provide: Table, useValue: table}, {provide: TableService, useValue: table.tableService}
    ], parent: this.injector});
  }
}
